import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { shallowEqual } from 'react-redux';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Button from '../../../components/library/buttons/Button';
import AccordionRight from '../../../components/library/graphics/AccordionRight';
import AvailableProductsListBox from './AvailableProductsListBox';
import AssignedProductsListBox from './AssignedProductsListBox';
import '../../../stylesheets/custom_scrollbar.scss';
import './AutoAssignModal.scss';

const AutoAssignModalProductsTab = (props) => {

    const { onChanged, availableProducts, assignedProducts } = props

    // arrays to hold local values for checked and assigned office ids
    const [checkedProducts, setCheckedProducts] = useState([])

    const handleAssignedProductsChanged = products => {
        if (!shallowEqual(products, assignedProducts)) {
            onChanged(products)
        }
    }

    const handleCheckedProductsChanged = products => {
        if (!shallowEqual(products, checkedProducts)) {
            setCheckedProducts(products)
        }
    }

    const handleAssignButtonClicked = () => {
        // union the existing assigned id list with the checked office lsit
        let newProducts = Array.from(new Set(assignedProducts.concat(checkedProducts)))
        // clear all checked selections
        setCheckedProducts([])
        // notify
        onChanged(newProducts)
    }

    return (
        <Fragment>
            <div className='columns content'>
                <div className='column is-10 is-offset-1'>
                    <p className='p1 has-text-weight-bold my-2'><HrbTranslate text='AssociateOfficesModal.ProductsHeader' /></p>
                    <p className='p2 content mb-3'><HrbTranslate text='AssociateOfficesModal.ProductsDescription' /></p>
                </div>
            </div>
            <div className='columns content'>
                <div className='column is-10 is-offset-1 columns px-0 py-0'>
                    <AvailableProductsListBox
                        availableProducts={availableProducts}
                        checkedProducts={checkedProducts}
                        onCheckedProductsChanged={handleCheckedProductsChanged} />
                    <div className='column is-2 is-flex is-justify-content-center is-align-content-center mt-5'>
                        <Button elementId='office-assign-btn'
                            buttonStyles='icon-button'
                            onClick={handleAssignButtonClicked}
                            disabled={(checkedProducts?.length === 0)}>
                            <AccordionRight />
                        </Button>
                    </div>
                    <AssignedProductsListBox
                        assignedProducts={assignedProducts}
                        onAssignedProductsChanged={handleAssignedProductsChanged} />
                </div>
            </div>
        </Fragment>
    );
}

AutoAssignModalProductsTab.whyDidYouRender = false;

AutoAssignModalProductsTab.propTypes = {
    impersonatingId: PropTypes.number,
    associate: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
    onUpdated: PropTypes.func,
    onCancel: PropTypes.func
}

export default AutoAssignModalProductsTab